/**
 * SEO blog articles — Arabic, Egyptian dialect.
 * Each article targets specific keywords to attract organic search traffic.
 *
 * Rules:
 * - Written in Egyptian dialect (not MSA) for better engagement
 * - 600-1200 words (Google's sweet spot for authority)
 * - Internal links to /register, /browse, other articles
 * - Each article has unique meta description with primary keyword
 */

export const articles = [
  {
    slug: 'kayfa-akhtar-sharik-hayati-bi-tariqa-shareya',
    title: 'اختيار شريك الحياة في الإسلام: ٣ معايير و٦ أسئلة مصيرية',
    description: 'الدين والخلق، التوافق في القيم، وموافقة الأهل: التلات معايير بالتفصيل، مع ٦ أسئلة تُسأل قبل الموافقة، وعلامات الزوج والزوجة الصالحة والاستخارة.',
    keywords: ['زواج حلال', 'شريك الحياة', 'زواج شرعي', 'اختيار الزوج'],
    category: 'نصائح زواج',
    readTime: '7 دقائق',
    publishedAt: '2026-04-01',
    lastUpdated: '2026-08-06',
    content: `
## بسم الله الرحمن الرحيم

اختيار شريك الحياة من أهم القرارات اللي بتاخدها في حياتك كلها. في الإسلام، الزواج مش مجرد علاقة، ده "ميثاق غليظ" اتكلم عنه القرآن الكريم.

## معايير اختيار الشريك في الإسلام

### 1. الدين والخلق
قال رسول الله صلى الله عليه وسلم: **"تُنكَح المرأةُ لأربعٍ: لمالِها ولِحسَبِها ولِجمالِها ولدينِها، فاظفَر بذاتِ الدينِ تَرِبَت يَداك"**.

الدين والخلق هما الأساس اللي بيحافظوا على البيت في الأوقات الصعبة. شخص ملتزم دينياً وعنده أخلاق كويسة هيكون في ضهرك دايماً.

ودي مش وجهة نظرنا إحنا: [دار الإفتاء المصرية](https://www.dar-alifta.org/ar/fatwa/details/17635/%D8%B6%D9%88%D8%A7%D8%A8%D8%B7-%D8%B4%D8%B1%D8%B9%D9%8A%D8%A9-%D9%81%D9%8A-%D8%A7%D9%84%D8%A7%D8%AE%D8%AA%D9%8A%D8%A7%D8%B1-%D8%B9%D9%86%D8%AF-%D8%A7%D9%84%D8%B2%D9%88%D8%A7%D8%AC) في فتوى **"ضوابط شرعية في الاختيار عند الزواج"** بتقرّر إن الأصل في الاختيار هو الدين والخلق، من غير ما ده يمنع إن الواحد يراعي باقي الصفات اللي تريحه.

### 2. التوافق في القيم والأهداف
لو انت شايف إن التعليم مهم، لازم شريكك يشاركك نفس الرؤية. لو انت عايز أولاد بسرعة، وهي مش مستعجلة، ده هيعمل مشاكل بعدين.

### 3. الموافقة والقبول من الأسرة
الزواج مش بس اتنين بيتجوزوا، دي عيلتين بيتقربوا. موافقة الأهل بتضمن دعمهم ليكم في الأوقات الصعبة.

## أسئلة مهمة لازم تسألها قبل الزواج

- إيه تصورك عن الحياة الزوجية؟
- عاوز كم ولد؟ وامتى؟
- إيه موقفك من شغل الزوجة؟
- إزاي بتتعامل لما تزعل؟
- إيه مفهومك عن القوامة؟
- إيه خططك المالية للخمس سنين الجاية؟

## علامات الزوج الصالح باختصار

1. **بيحافظ على الصلاة**: ده أول وأهم علامة
2. **بيحترم أهله وأمه**: اللي ببيحترم أمه هيحترم زوجته
3. **أمين في شغله**: الأمانة صفة أساسية
4. **متواضع مش متكبر**: الكبر بيخرب البيوت
5. **بيستشير قبل ما ياخد قرار**: ده ذكاء عاطفي

دي الخلاصة السريعة. لو عندك خاطب بعينه دلوقتي وعايزة القائمة الكاملة بالعلامات التحذيرية والأسئلة، اقرأي: **[علامات الزوج الصالح — ١٠ صفات تشوفيها في الخاطب](/blog/alamat-al-zawj-al-salih)**.

## علامات الزوجة الصالحة

1. **ملتزمة بحدود الشرع**: في ملبسها وتصرفاتها
2. **رشيدة في الإنفاق**: مش مبذّرة ولا بخيلة
3. **بتحفظ لسانها**: مش نمّامة ولا غيّابة
4. **بتحب عيلتها وعيلة زوجها**
5. **فيها حياء وحشمة**

## كيف تتأكد من اختيارك؟

### الاستخارة
صلاة الاستخارة ركعتين وبعدها دعاء. بعدها لو قلبك ارتاح وحسيت راحة، ده من علامات القبول. لو حسيت قلق، ممكن يكون مش مناسب ليك.

الصفة الكاملة للصلاة والدعاء موجودة في فتوى [صلاة الاستخارة وكيف تعرف نتيجتها — دار الإفتاء المصرية](https://www.dar-alifta.org/ar/fatwa/details/11388/%D8%B5%D9%84%D8%A7%D8%A9-%D8%A7%D9%84%D8%A7%D8%B3%D8%AA%D8%AE%D8%A7%D8%B1%D8%A9-%D9%88%D9%83%D9%8A%D9%81-%D8%AA%D8%B9%D8%B1%D9%81-%D9%86%D8%AA%D9%8A%D8%AC%D8%AA%D9%87%D8%A7)، وبتوضّح إن الاستخارة تفويض الأمر لله، وإن علامتها التيسير — مش شرط تشوف رؤيا، وتقدر تكرّرها لحد ما ينشرح صدرك.

### المشورة
استشير أهلك وناس تثق فيهم. البعض بيشوف حاجات انت مش بتشوفها.

### الوقت الكافي
مش لازم تستعجل. اديها وقتها وخد وقتك في المعرفة (في إطار شرعي طبعاً).

## وفّقنا: الطريق الحلال للزواج في مصر

في وفّقنا، إحنا مبنينا التطبيق على أساس إسلامي خالص:

- **مفيش صور منشورة**: حفاظاً على الخصوصية
- **الأهل بيملأوا بروفايل البنت**: ضمان الأمانة
- **مراجعة إدارية لكل بروفايل**: ضماناً للجدية
- **التواصل بموافقة الطرفين**: احترام لخصوصية البنات

[سجل الآن في وفّقنا مجاناً](/register)

## خلاصة

اختيار شريك الحياة رحلة محتاجة صبر، استخارة، ومشورة. لما تركز على الدين والخلق، وتستشير أهلك، وتستخير ربنا، هتلاقي الطريق الصح بإذن الله.

ربنا يوفقك ويرزقك الحلال الطيب 🤲

## مراجع ومصادر رسمية

- [ضوابط شرعية في الاختيار عند الزواج — دار الإفتاء المصرية](https://www.dar-alifta.org/ar/fatwa/details/17635/%D8%B6%D9%88%D8%A7%D8%A8%D8%B7-%D8%B4%D8%B1%D8%B9%D9%8A%D8%A9-%D9%81%D9%8A-%D8%A7%D9%84%D8%A7%D8%AE%D8%AA%D9%8A%D8%A7%D8%B1-%D8%B9%D9%86%D8%AF-%D8%A7%D9%84%D8%B2%D9%88%D8%A7%D8%AC)
- [صلاة الاستخارة وكيف تعرف نتيجتها — دار الإفتاء المصرية](https://www.dar-alifta.org/ar/fatwa/details/11388/%D8%B5%D9%84%D8%A7%D8%A9-%D8%A7%D9%84%D8%A7%D8%B3%D8%AA%D8%AE%D8%A7%D8%B1%D8%A9-%D9%88%D9%83%D9%8A%D9%81-%D8%AA%D8%B9%D8%B1%D9%81-%D9%86%D8%AA%D9%8A%D8%AC%D8%AA%D9%87%D8%A7)
- [مركز الأزهر العالمي للفتوى الإلكترونية](https://azhar.eg/fatwacenter) — لو حالتك ليها ظروف خاصة، تقدر تبعت سؤالك للمركز مباشرة.

## محتوى ذو صلة

- [أسس اختيار شريك الحياة: إطار قرار من ٦ معايير](/blog/osos-ikhtiyar-sharik-al-hayat) — لو عايزة تحوّلي الكلام ده لقرار: ترتيب المعايير، قاعدة التلاتة، وإزاي تتكلمي مع أهلك بيها.
- [علامات الزوج الصالح — ١٠ صفات تشوفيها في الخاطب](/blog/alamat-al-zawj-al-salih)
- [صلاة الاستخارة للزواج: الطريقة والدعاء وعلامات الإجابة](/blog/al-istikhara-qabl-al-zawaj)
`,
  },
  {
    slug: 'alamat-al-zawj-al-salih',
    title: 'علامات الزوج الصالح في الإسلام — ١٠ صفات تشوفيها في الخاطب',
    description: 'قدّامك خاطب ومحتاجة تحكمي عليه؟ ١٠ من علامات وصفات الزوج الصالح تقدري تلاحظيها بنفسك، علامات تحذيرية توقّفك، وأسئلة تسأليها عنه قبل ما توافقي.',
    keywords: ['علامات الزوج الصالح في الإسلام', 'الزوج الصالح', 'الرجل الصالح في الإسلام', 'صفات الزوج الصالح', 'صفات الزوج المسلم', 'إزاي أعرف الخاطب مناسب', 'تقييم الخاطب قبل الموافقة'],
    faq: [
      {
        question: 'ما هي أهم علامات الزوج الصالح في الإسلام؟',
        answer: 'أهم العلامات: المحافظة على الصلاة، حسن الخلق مع أهله، الأمانة في العمل، احترام والديه، الاعتدال المالي، وصدق الحديث. قال ﷺ: "إذا خطب إليكم من ترضون دينه وخلقه فزوجوه".'
      },
      {
        question: 'كيف أعرف أن الخاطب مناسب فعلاً وليس مجرد كلام؟',
        answer: 'الكلام سهل، الأفعال هي الميزان. اسألي عنه من زملائه في العمل ومن جيرانه، لا من أهله فقط. لاحظي إزاي بيتعامل مع أمه ومع الخدم في المطعم، هيتعامل معك زيّ ما بيتعامل معهم.'
      },
      {
        question: 'هل الالتزام الديني وحده يكفي لاختيار الزوج؟',
        answer: 'لا. الرسول ﷺ ذكر الدين والخلق معاً. راجل بيصلي لكن أخلاقه سيئة أو بخيل أو عصبي مش زوج صالح. الدين بدون خلق ناقص، والخلق بدون دين غير مستقر.'
      },
      {
        question: 'ما دور الأهل في تقييم الخاطب؟',
        answer: 'دور مهم جداً. الأهل بيشوفوا اللي البنت المتحمسة مبتشفوش. اسألي والدك أو أخوك يقعدوا معاه، يسألوه عن شغله وأهله وخططه، ويتابعوا رد فعله لما يتضغط شوية.'
      },
      {
        question: 'هل الفارق المادي بيني وبين الخاطب مشكلة؟',
        answer: 'الفارق البسيط طبيعي، الفارق الكبير المستمر بيسبب مشاكل. الأهم من الفلوس هو استقراره المالي والوظيفي. راجل بيدور على وظيفة من سنة وبيصرف من أهله = مؤشر خطر.'
      }
    ],
    category: 'نصائح زواج',
    readTime: '6 دقائق',
    publishedAt: '2026-04-02',
    lastUpdated: '2026-08-06',
    content: `
## قدّامك خاطب بعينه — والسؤال: هو ده الزوج الصالح ولا لأ؟

المقال ده مكتوب لواحدة (أو لأهلها) قدّامها خاطب محدد دلوقتي، ومحتاجة تحكم عليه من غير ما تظلمه ولا تستعجل. مش كلام نظري عن المثالية — دي **علامات تقدري تلاحظيها بنفسك** في تصرفاته وفي كلامه، وعلامات تحذيرية تخليكي تقفي، وأسئلة محددة تسأليها عنه قبل ما تقولي "موافقة".

لو سؤالك مختلف — يعني إنتي عايزة تعرفي الأول **إيه اللي الإسلام نفسه بيقوله عن الرجل الصالح** من القرآن والسنة كمفهوم شرعي، مش تقييم خاطب معيّن — فده موضوع تاني وهتلاقيه هنا: **[الرجل الصالح في الإسلام: ١٢ صفة من القرآن والسنة](/blog/al-rajul-al-saleh-fil-islam)**. وبعدها ارجعي للعلامات العملية اللي تحت.

## الميزان الشرعي في جملة واحدة

اختيار الزوج قرار مصيري. الرسول صلى الله عليه وسلم قال: **"إذا خطب إليكم من ترضون دينه وخلقه فزوجوه"**. يعني إيه "ترضون دينه وخلقه"؟ دي العلامات اللي لازم تدوري عليها.

والحديث ده هو نفسه اللي بتستند عليه [دار الإفتاء المصرية](https://www.dar-alifta.org/ar/fatwa/details/17635/%D8%B6%D9%88%D8%A7%D8%A8%D8%B7-%D8%B4%D8%B1%D8%B9%D9%8A%D8%A9-%D9%81%D9%8A-%D8%A7%D9%84%D8%A7%D8%AE%D8%AA%D9%8A%D8%A7%D8%B1-%D8%B9%D9%86%D8%AF-%D8%A7%D9%84%D8%B2%D9%88%D8%A7%D8%AC) في فتوى **"ضوابط شرعية في الاختيار عند الزواج"**، لما بتقرّر إن الدين والخلق هما الأساس، والباقي صفات تُراعى بعدهم مش قبلهم.

## ١٠ علامات للزوج الصالح تقدري تشوفيها بنفسك

كل علامة تحت دي حاجة **تتلاحظ**، مش حاجة تتقال. ركّزي على تصرفاته لما مايكونش فاكر إنك بتقيّميه.

### 1. بيحافظ على الصلاة في أوقاتها
أول وأهم علامة. الراجل اللي بيصلي بانتظام عنده ميزان أخلاقي داخلي. قال تعالى: **"إِنَّ الصَّلاةَ تَنْهَى عَنِ الْفَحْشَاءِ وَالْمُنْكَر"**.

### 2. بيحترم أمه ويبرّها
**"الجنة تحت أقدام الأمهات"**. الراجل اللي بيحترم أمه، هيحترم مراته. ولو بيتعامل معاها بقسوة، توقعي نفس المعاملة.

### 3. عنده خلق في الكلام
مش بيسبّ، مش بيشتم، مش بيرفع صوته. كلامه محترم حتى لما بيزعل.

### 4. أمين في شغله ومعاملاته
لو بيغش في شغله، ممكن يغش في زواجه. الأمانة صفة شاملة.

### 5. بيحافظ على صلة الرحم
بيزور أهله، بيتواصل معاهم، بيساعدهم. ده دليل على كرم النفس.

### 6. عنده مسؤولية مالية
مش لازم يكون غني، لكن بيدبّر أموره. عنده شغل أو خطة واضحة.

### 7. عفيف
مش بيتحرش، مش بيبص للحرام، مش بيكلم بنات على النت. العفة صفة نادرة ومهمة.

### 8. بيتقبل النصيحة
متكبر؟ عنيد؟ مش بيسمع الكلام؟ توقعي مشاكل. الراجل الصالح بيستشير وبيتقبل الرأي.

### 9. بيحترم الست
بيتعامل مع أخته، عمته، جارته باحترام. مش بيقلل من قيمة الستات.

### 10. بيتقبل الخطأ ويعتذر
الكمال لله. الراجل اللي بيقدر يقول "أنا غلطت، سامحيني" ده راجل محترم.

## علامات تحذيرية

- **بيسب الوالدين**
- **بيكذب في حاجات صغيرة**
- **بيتكلم بسوء عن خطيباته السابقات**
- **متكبر ومغرور**
- **عدواني في الكلام**
- **بخيل جداً**
- **مش بيسمع للنصيحة**

لو شفتي أي علامة من دول، وقفي وفكري كويس.

## كيف تعرفي أكتر قبل ما تقرري؟

### اسألي أهله وأصحابه
الناس اللي حواليه بيعرفوه أكتر منك. اسألي بذكاء.

ولو حد اتسأل عنه وكان عارف فيه عيب حقيقي وقال لك، ده نصيحة مش غيبة — راجعي فتوى [حكم الإخبار بما في الخاطب من عيوب — دار الإفتاء المصرية](https://www.dar-alifta.org/ar/fatwa/details/22034/%D8%AD%D9%83%D9%85-%D8%A7%D9%84%D8%A5%D8%AE%D8%A8%D8%A7%D8%B1-%D8%A8%D9%85%D8%A7-%D9%81%D9%8A-%D8%A7%D9%84%D8%AE%D8%A7%D8%B7%D8%A8-%D9%85%D9%86-%D8%B9%D9%8A%D9%88%D8%A8)، والأصل فيها حديث **"المستشار مؤتمن"**.

### شوفيه في مواقف الضغط
لما يزعل، لما يتعب، لما حد يغلط معاه. هنا بيظهر الخلق الحقيقي.

### اعرفي خلفيته وقيمه
إيه رأيه في التعليم؟ الشغل؟ الأولاد؟ الأهل؟ المال؟

## وفّقنا: ضمان الاختيار الصح

في وفّقنا بنطلب من الشباب بروفايل تفصيلي:
- الحالة الدينية
- الوظيفة والدخل
- الحالة الصحية
- الأسرة والخلفية
- المواصفات الشخصية

وكل ده بيمر **بمراجعة إدارية** قبل ما يظهر لحد. [تعرفي على البروفايلات المتاحة](/browse)

## خلاصة

الزوج الصالح مش كامل، لكن عنده خط أخلاقي واضح. بيحافظ على صلاته، بيحترم أهله، وبيتعامل بأمانة.

وعلشان تلاقي الشخص ده في مكان محترم وآمن، اقرأي دليلنا عن **[أفضل موقع زواج حلال مجاني في مصر](/blog/mawqi-zawaj-halal-majani-masr)** — بموافقة الأهل، من غير صور منشورة، ومجاني بالكامل.

ربنا يرزقك الزوج الصالح يا رب 🤲

## مراجع ومصادر رسمية

- [ضوابط شرعية في الاختيار عند الزواج — دار الإفتاء المصرية](https://www.dar-alifta.org/ar/fatwa/details/17635/%D8%B6%D9%88%D8%A7%D8%A8%D8%B7-%D8%B4%D8%B1%D8%B9%D9%8A%D8%A9-%D9%81%D9%8A-%D8%A7%D9%84%D8%A7%D8%AE%D8%AA%D9%8A%D8%A7%D8%B1-%D8%B9%D9%86%D8%AF-%D8%A7%D9%84%D8%B2%D9%88%D8%A7%D8%AC)
- [حكم الإخبار بما في الخاطب من عيوب — دار الإفتاء المصرية](https://www.dar-alifta.org/ar/fatwa/details/22034/%D8%AD%D9%83%D9%85-%D8%A7%D9%84%D8%A5%D8%AE%D8%A8%D8%A7%D8%B1-%D8%A8%D9%85%D8%A7-%D9%81%D9%8A-%D8%A7%D9%84%D8%AE%D8%A7%D8%B7%D8%A8-%D9%85%D9%86-%D8%B9%D9%8A%D9%88%D8%A8)
- [مركز الأزهر العالمي للفتوى الإلكترونية](https://azhar.eg/fatwacenter)

## محتوى ذو صلة

- [الرجل الصالح في الإسلام: ١٢ صفة من القرآن والسنة](/blog/al-rajul-al-saleh-fil-islam) — لو سؤالك عن المفهوم الشرعي نفسه (آيات وأحاديث وكلام أهل العلم)، مش عن تقييم خاطب بعينه.
- [صفات الرجل المناسب للزواج — ٧ معايير حقيقية](/blog/safat-al-rajul-al-monaseb-lil-zawaj) — التوافق بينك وبينه إنتي تحديداً: السن، التعليم، الشغل، السكن.
- [أسئلة تسألها البنت للخاطب — الدليل الكامل](/blog/asilah-taskaha-al-bint-lil-khateb) — الأسئلة اللي تحوّل العلامات دي لكلام مباشر معاه.
- [السؤال عن الخاطب: مين تسألي وتسألي إيه بالظبط](/blog/al-tahari-an-al-khateb) — التحقّق من برّه العلامات دي بالسؤال عنه، مش بكلامه هو.
- [استخارة الزواج بمن تحب: لما قلبك يكون مايل خلاص](/blog/istikhara-al-zawaj-biman-tuhib) — لو العلامات موجودة وقلبك مايل وخايفة تكوني بتضحكي على نفسك.
- [دليل الأم: خطوات عملية قبل ما توافقي على خاطب لبنتك](/blog/daleel-al-omm-li-ikhtiyar-aris-li-bintaha) — لو إنتي الأم أو ولي الأمر.
`,
  },
  {
    slug: 'mawqi-zawaj-halal-majani-masr',
    title: 'أفضل موقع زواج حلال مجاني في مصر 2026',
    description: 'موقع زواج حلال مجاني في مصر، من غير اشتراك ولا رسوم مخفية: الصور مش منشورة، ولي الأمر اختياري مش شرط، وكل بروفايل بيتراجع قبل ما يظهر للناس.',
    keywords: ['موقع زواج مجاني', 'موقع زواج مصري', 'زواج حلال مصر', 'تطبيق زواج اسلامي'],
    faq: [
      {
        question: 'هل موقع وفّقنا مجاني بالكامل؟',
        answer: 'نعم. التسجيل مجاني، إنشاء البروفايل مجاني، إرسال طلبات التواصل مجاني، والمحادثة مجانية. لا يوجد اشتراك مدفوع ولا ميزات مخفية وراء دفعة.'
      },
      {
        question: 'ما الفرق بين وفّقنا وباقي مواقع الزواج؟',
        answer: 'ثلاثة فروق أساسية: (١) الصور لا تُنشر علناً — تُشارك فقط بموافقة الطرفين. (٢) ولي الأمر جزء من العملية من أول خطوة، مش مضاف بعدين. (٣) مراجعة بشرية لكل بروفايل قبل الظهور — مش أي حد يقدر يعمل حساب.'
      },
      {
        question: 'كيف يتم التحقق من هوية المستخدمين؟',
        answer: 'كل مستخدم بيرفع صورة بطاقة الرقم القومي عند التسجيل. فريق وفّقنا بيراجعها يدوياً قبل تفعيل الحساب. الحسابات غير الموثّقة لا تظهر في البحث.'
      },
      {
        question: 'هل ولي الأمر يقدر يتابع البروفايل؟',
        answer: 'نعم. رقم ولي الأمر (الأب أو الأخ) بيتم إدخاله عند التسجيل، وأي طلب تواصل بيوصل إشعار للاتنين. المفروض ولي الأمر يكون طرف من أول خطوة.'
      },
      {
        // Phrased the way people actually search it. `بالصور` queries carry
        // ~1,555 impressions on this page at positions 6.7-9.4 (Search
        // Console, 90 days to 2026-09-29) and the page previously read as
        // contradicting them — it said profiles have no photos at all, which
        // stopped being true when private profile photos shipped.
        question: 'هل وفّقنا موقع زواج بالصور؟',
        answer: 'الصور موجودة بس مش منشورة. مفيش صورة بتظهر في التصفح العام لأي حد ولا في نتايج البحث. الصورة اللي في بروفايلك بتوصل بس للشخص اللي بينك وبينه محادثة مفتوحة بعد موافقة الطرفين، وجوّه المحادثة فيه كمان صور للعرض مرة واحدة بتتمسح بعد المشاهدة.',
      },
      {
        question: 'هل الصور مرئية للجميع؟',
        answer: 'لا. الصور مخفية بالكامل في التصفح العام. بعد قبول طلب التواصل من الطرفين، يقدروا يطلبوا مشاركة صور — مرة واحدة وبيتم حذفها بعد المشاهدة.'
      },
      {
        question: 'كم مدة الرد على طلبات التواصل؟',
        answer: 'لا يوجد مدة إلزامية، لكن ننصح بالرد خلال ٣-٧ أيام حفاظاً على تجربة الطرف الآخر. البروفايلات النشطة (اللي بترد بسرعة) بتظهر بترتيب أعلى في التصفح.'
      }
    ],
    category: 'عن وفّقنا',
    readTime: '5 دقائق',
    publishedAt: '2026-04-03',
    lastUpdated: '2026-09-29',
    content: `
## مقدمة

في عصر مواقع الزواج الكتير، إزاي تختار اللي يناسبك وبيحترم قيمك؟ السؤال الأهم: **هل الموقع ده ملتزم بالشرع؟** وإزاي تضمن الجدية والأمان؟

## المشاكل الشائعة في مواقع الزواج

### 1. نشر الصور علناً
معظم التطبيقات زي Muzz بتنشر الصور علناً. ده مش مناسب للبنات اللي بيحترموا الخصوصية.

### 2. الاشتراكات المكلفة
**١٥ دولار شهرياً؟!** في وقت الأزمات الاقتصادية، ده غير منطقي.

### 3. نصب واحتيال
في ناس كتير بتتعرض للنصب من حسابات وهمية.

### 4. عدم مشاركة الأهل
الأهل مش جزء من العملية، ده ضد القيم المصرية والإسلامية.

## حل وفّقنا

**وفّقنا** أول تطبيق مصري بيحل كل المشاكل دي:

### ✅ مجاني ١٠٠٪
مفيش أي اشتراك مدفوع. الخدمات كاملة مجانية.

### ✅ مفيش صور منشورة
مفيش أي صورة بتظهر في التصفح العام — لا لحد بيتصفّح ولا في نتايج البحث. ولو حابب تحطّ صورة في بروفايلك، بتفضل مقفولة: محدش يشوفها غير الشخص اللي بينك وبينه محادثة مفتوحة فعلاً، يعني بعد ما الطرفين يوافقوا على التواصل. وجوّه المحادثة نفسها تقدروا تتبادلوا صورة للعرض **مرة واحدة بس**، وبتتمسح بعد ما تتشاف.

التواصل بيبدأ بالمواصفات والأخلاق، مش المظهر. مش معناه إن الصورة مش موجودة خالص — معناه إنها بتوصل للشخص اللي إنت اخترت تتكلم معاه، ومحدش تاني.

### ✅ إشراك ولي الأمر — باختيارها
العروس تسجّل بنفسها أو يسجّلها ولي أمرها وتظل هي المتحكمة، وتقدر تدعو **ولي أمرها لمتابعة محادثاتها** (للاطّلاع فقط) في أي وقت. إشراك العائلة بيزود الطمأنينة، من غير إلزام.

### ✅ مراجعة إدارية
كل بروفايل بتمر بمراجعة إدارية قبل ما تظهر، علشان نتأكد من الجدية.

### ✅ تحقق من الهوية
إمكانية رفع هوية للتحقق، لضمان أن المستخدم حقيقي.

### ✅ خصوصية تامة
التواصل بيحصل بس لما الطرفين يوافقوا. البنت مش بتتفاجأ بأي رسائل.

## الضوابط الشرعية للتعارف قبل الخِطبة

الكلام بين الشاب والبنت بغرض التعارف قبل الخِطبة مش ممنوع في ذاته، لكن ليه ضوابط. [دار الإفتاء المصرية](https://www.dar-alifta.org/ar/fatwa/details/19203/%D8%AD%D8%AF%D9%88%D8%AF-%D8%A7%D9%84%D8%AA%D8%B9%D8%A7%D8%B1%D9%81-%D8%A8%D9%8A%D9%86-%D8%A7%D9%84%D8%B1%D8%AC%D9%84-%D9%88%D8%A7%D9%84%D9%85%D8%B1%D8%A3%D8%A9-%D9%82%D8%A8%D9%84-%D8%A7%D9%84%D8%AE%D9%90%D8%B7%D8%A8%D8%A9-%D9%88%D8%A7%D9%84%D8%B6%D9%88%D8%A7%D8%A8%D8%B7-%D8%A7%D9%84%D8%B4%D8%B1%D8%B9%D9%8A%D8%A9-%D9%84%D8%B0%D9%84%D9%83) في فتوى **"حدود التعارف بين الرجل والمرأة قبل الخِطبة والضوابط الشرعية لذلك"** بتذكر تلات ضوابط: غض البصر، وإن الكلام مايكونش فيه خضوع بالقول، وإن ميحصلش خلوة محرمة.

وده اللي التطبيق متبني عليه عملياً: التواصل مبيبدأش غير بموافقة الطرفين، والمحادثة بتفضل جوه التطبيق، والعروس تقدر تدعو ولي أمرها يتابع محادثاتها (للاطّلاع فقط) لو حابة.

## إزاي تبدأ؟

### للشباب:
1. اضغط [تسجيل شاب](/register?type=male)
2. املأ بروفايلك بالتفاصيل
3. تابع البروفايلات المتاحة
4. ابعت طلب تواصل للمناسبة

### للبنات وأولياء أمورهم:
1. اضغط [تسجيل فتاة](/register?type=female)
2. العروس تسجّل بنفسها أو يسجّلها ولي أمرها وتملأ بروفايلها
3. تقدر تدعو **وليّها لمتابعة محادثاتها** (للاطّلاع فقط) — اختياري
4. الموافقة من الطرفين بتفتح التواصل

## مقارنة سريعة

| الميزة | وفّقنا | Muzz | التطبيقات الأخرى |
|--------|--------|------|------------------|
| السعر | مجاني | $15/شهر | مدفوع |
| الصور | مخفية | علنية | علنية |
| مشاركة الأهل | نعم | لا | لا |
| مراجعة إدارية | نعم | لا | لا |
| التركيز | مصر | عالمي | متعدد |
| اللغة | عربي | متعدد | متعدد |

## شهادات مستخدمين

> "التطبيق الوحيد اللي حسيت فيه بالأمان على بنتي. الأهل جزء من العملية من الأول للآخر." — **أم محمد، القاهرة**

> "وفّقنا غير تصوري عن تطبيقات الزواج. مفيش تبذّل، مفيش ضغط. كله محترم." — **أحمد، الإسكندرية**

## اقرأ كمان قبل ما تبدأ

اختيار شريك الحياة قرار يستاهل تجهيز كويس. قبل ما تسجل، فيه ٣ مقالات هتفيدك:

- 📘 **[إزاي تختار شريك حياتك بطريقة شرعية](/blog/kayfa-akhtar-sharik-hayati-bi-tariqa-shareya)** — دليل شامل للشاب اللي بيدور على الزوجة الصالحة، بناءً على معايير الفقه الإسلامي والنصائح المعاصرة.
- 👩‍👧 **[البحث عن عريس لبنتي - دليل الأم المصرية](/blog/ezay-adawwar-ala-aris-li-binty)** — لو إنتي أم بتدوّري لبنتك، المقال ده مكتوب لكِ خطوة بخطوة، يجاوب على أسئلتك المهمة.
- 🛡️ **[علامات الحساب الموثوق وإزاي تختار موقع زواج آمن](/blog/zawaj-bidoon-nasab)** — أهم نصائح الأمان قبل ما تبعت أي طلب تواصل، لحماية وقتك وفلوسك وأهلك.

كل المقالات دي مجانية والقراية بتاخد دقايق بس. إنت في وفّقنا لإنك جاد، فاستثمر شوية وقت في فهم الموضوع كويس.

## من خارج مصر؟

وفّقنا بيخدم كل الدول العربية والجاليات في المهجر، ومعانا أدلة مخصصة لكل بلد بلهجته وظروفه:

- 🇸🇦 **[موقع زواج حلال مجاني في السعودية](/blog/mawqi-zawaj-saudi-majani)** — للسعوديين والمقيمين، بإشراف الأهل وبدون صور علنية.
- 🇸🇾 **[زواج حلال للسوريين داخل سوريا والمهجر](/blog/zawaj-halal-suria-2026)** — منصّة آمنة تجمع شمل السوريين للزواج الشرعي.
- 🇩🇿 **[موقع زواج جزائري حلال مجاني](/blog/mawqi-zawaj-jazairi-majani)** — تعارف للزواج بالحلال في الجزائر، مجاناً وبخصوصية.
- 🇲🇦 **[زواج حلال في المغرب](/blog/zawaj-halal-fi-al-maghrib-2026)** — للمغاربة الباحثين عن شريك حياة بالطريقة الشرعية.

## ابدأ رحلتك دلوقتي

[سجل مجاناً في وفّقنا](/register)

وقبل ما تختار، صلّي **[ركعتين استخارة قبل الزواج](/blog/al-istikhara-qabl-al-zawaj)** — قرار الزواج محتاج راحة بال وتوفيق من ربنا. اعمل الأسباب، واستخير، وسلّم لله.

ربنا يوفق الجميع ويرزقنا الحلال الطيب 🌹

## مراجع ومصادر رسمية

- [حدود التعارف بين الرجل والمرأة قبل الخِطبة والضوابط الشرعية لذلك — دار الإفتاء المصرية](https://www.dar-alifta.org/ar/fatwa/details/19203/%D8%AD%D8%AF%D9%88%D8%AF-%D8%A7%D9%84%D8%AA%D8%B9%D8%A7%D8%B1%D9%81-%D8%A8%D9%8A%D9%86-%D8%A7%D9%84%D8%B1%D8%AC%D9%84-%D9%88%D8%A7%D9%84%D9%85%D8%B1%D8%A3%D8%A9-%D9%82%D8%A8%D9%84-%D8%A7%D9%84%D8%AE%D9%90%D8%B7%D8%A8%D8%A9-%D9%88%D8%A7%D9%84%D8%B6%D9%88%D8%A7%D8%A8%D8%B7-%D8%A7%D9%84%D8%B4%D8%B1%D8%B9%D9%8A%D8%A9-%D9%84%D8%B0%D9%84%D9%83)
- [ضوابط شرعية في الاختيار عند الزواج — دار الإفتاء المصرية](https://www.dar-alifta.org/ar/fatwa/details/17635/%D8%B6%D9%88%D8%A7%D8%A8%D8%B7-%D8%B4%D8%B1%D8%B9%D9%8A%D8%A9-%D9%81%D9%8A-%D8%A7%D9%84%D8%A7%D8%AE%D8%AA%D9%8A%D8%A7%D8%B1-%D8%B9%D9%86%D8%AF-%D8%A7%D9%84%D8%B2%D9%88%D8%A7%D8%AC)
- [مركز الأزهر العالمي للفتوى الإلكترونية](https://azhar.eg/fatwacenter)

## محتوى ذو صلة

- [موقع زواج بالصور ولا من غير صور؟ الفرق اللي بيحميكِ](/blog/zawaj-bil-sowar-am-bidoon-sowar) — أهم سؤال بيقلق البنات قبل التسجيل: مين بيشوف الصورة، وإزاي بيبدأ الابتزاز، وإيه اللي تعمليه لو حصل.
- [أسس اختيار شريك الحياة: إطار قرار من ٦ معايير](/blog/osos-ikhtiyar-sharik-al-hayat) — إطار عملي يرتّب المعايير قبل ما تبدأ تدوّر.
`,
  },
  {
    slug: 'ezay-adawwar-ala-aris-li-binty',
    title: 'البحث عن عريس لبنتي - دليل الأم المصرية الكامل ٢٠٢٦',
    description: '٥ خطوات من تحديد المواصفات لحد الاستخارة، ٧ علامات إن العريس مناسب و٧ علامات تحذيرية توقّفك، وإزاي تسألي عنه وتجمعي معلومات من غير ما تحرجي بنتك.',
    keywords: ['البحث عن عريس', 'زواج البنت', 'دور الأم في الزواج', 'عريس لبنتي'],
    category: 'للأمهات',
    readTime: '8 دقائق',
    publishedAt: '2026-04-04',
    lastUpdated: '2026-08-06',
    content: `
## رسالة للأم الحنونة

أكيد بتحبي بنتك لأبعد الحدود، وعاوزالها أفضل جوز ممكن. بس الدنيا اتغيرت، والناس مبقوش زي زمان. إزاي نعمل إيه علشان نلاقي الاختيار الصح؟

## الواقع الجديد

### مشاكل التقليدي:
- الخطابة مش دايماً بتوصلك لناس مناسبين
- المجاملات الاجتماعية ممكن تضيع فرص
- صعوبة الحصول على معلومات كاملة

### مشاكل الأونلاين العادي:
- مفيش رقابة على الجدية
- البنت بتتعرض لأشخاص مش محترمين
- مفيش حماية من النصب

## الحل الأمثل: التوازن

خلي الأمر في إيد الأهل من الأول، بس استخدمي التكنولوجيا بذكاء.

## خطوات عملية للبحث عن عريس

### الخطوة 1: حددي المواصفات
اقعدي مع بنتك واكتبوا:
- **العمر المطلوب**: فرق معقول ٣-١٠ سنين
- **الحالة الاجتماعية**: أعزب، مطلق، أرمل
- **المستوى التعليمي**
- **الوظيفة والدخل المعقول**
- **مستوى الالتزام الديني**
- **المحافظة أو المدينة**
- **أي شروط خاصة**

### الخطوة 2: اختاري القناة المناسبة
- **الأقارب والمعارف**: أفضل مصدر
- **مساجد وجمعيات خيرية**
- **مواقع زواج موثوقة** زي [وفّقنا](/register)

**تجنبي**: وسائل التواصل الاجتماعي المفتوحة، التطبيقات المجهولة.

### الخطوة 3: جمع المعلومات
لما ييجي عريس مناسب:
1. **اسألي عن أهله**: مين عيلته، فين ساكنين، سمعتهم
2. **اسألي عن شغله**: مكان شغله، دخله، استقراره
3. **اسألي ناس عرفاه**: مش بس أصحابه، ناس محايدة
4. **تحققي من الحالة الاجتماعية**: متجوز قبل كده؟ مطلق؟

ولو حد اتسأل عنه وكان عارف فيه عيب حقيقي وقال لك، ده نصيحة مش غيبة — راجعي فتوى [حكم الإخبار بما في الخاطب من عيوب — دار الإفتاء المصرية](https://www.dar-alifta.org/ar/fatwa/details/22034/%D8%AD%D9%83%D9%85-%D8%A7%D9%84%D8%A5%D8%AE%D8%A8%D8%A7%D8%B1-%D8%A8%D9%85%D8%A7-%D9%81%D9%8A-%D8%A7%D9%84%D8%AE%D8%A7%D8%B7%D8%A8-%D9%85%D9%86-%D8%B9%D9%8A%D9%88%D8%A8).

### الخطوة 4: المقابلة الأولى
- في مكان عام محترم
- في وجود ولي الأمر
- تركيز على الأساسيات مش التفاصيل

### الخطوة 5: الاستخارة
صلاة الاستخارة مهمة جداً. خلي بنتك تصلي واستخيري انتي كمان.

## علامات العريس المناسب

✅ **محترم للأهل**: من أول لقاء
✅ **واضح في كلامه**: مش بيدور ولا بيتهرّب
✅ **منطقي في طلباته**: مش ثقيل ولا مادي
✅ **متعلم أو عنده مهنة واضحة**
✅ **عايلته محترمة**
✅ **بيحترم بنتك**: مش بيقلل منها
✅ **عنده خطة للزواج**: مش مجرد كلام

## علامات تحذيرية ⚠️

❌ **بيطلب صور قبل المقابلة**
❌ **متسرّع**: عاوز يتجوز بعد أسبوع!
❌ **مش عاوز الأهل يشاركوا**
❌ **بيتكلم بطريقة غير محترمة**
❌ **بيحذّر من ناس معينة**
❌ **بيضغط على بنتك**
❌ **مش واضح في دخله**

## إزاي تتجنبي النصب؟

1. **محدش يطلب فلوس قبل الزواج** - ده نصب مضمون
2. **محدش يطلب صور خاصة** - هذا تحرش
3. **اسألي عن الهوية**: لو أهله بعيدين جداً، إسألي ليه
4. **لو حسيتي إن في حاجة غلط، وقفي**

## وفّقنا: أمان للأهل

في [وفّقنا](/register)، بنحل مشاكل الأهل:

- **إنتي بتملأي البروفايل** مش بنتك
- **طلبات التواصل بتيجي ليكي** وإنتي بتقرري
- **مراجعة إدارية** لكل بروفايل
- **مفيش صور منشورة** - حماية لخصوصية بنتك
- **محفوظيات**: تقدري تحفظي البروفايلات اللي عجبتك
- **إمكانية التواصل** بعد الموافقة من الطرفين

## كيف تتعاملي مع بنتك

- **اسمعيها**: إيه اللي عاوزاه في الجوز؟
- **اشركيها في القرار**: مش القرار عنها، بل معاها
- **ادعميها**: الزواج مش بس قرار، ده مرحلة جديدة
- **احتفظي بالهدوء**: لو رفضت واحد، هتجيلها حد أحسن

والنقطة دي محسومة شرعاً مش تربوياً بس: [دار الإفتاء المصرية](https://www.dar-alifta.org/ar/fatwa/details/11511/%D8%AD%D9%83%D9%85-%D8%A5%D8%AC%D8%A8%D8%A7%D8%B1-%D8%A7%D9%84%D9%81%D8%AA%D8%A7%D8%A9-%D8%B9%D9%84%D9%89-%D8%A7%D9%84%D8%B2%D9%88%D8%A7%D8%AC-%D9%85%D9%86-%D8%BA%D9%8A%D8%B1-%D9%83%D9%81%D8%A1-%D9%84%D9%87%D8%A7) بتنص على إنه **"لا يجوز شرعًا إجبار الفتاة البالغة العاقلة على قبول الزواج بغير من ترضاه"**. رضاها شرط، مش إجراء شكلي.

## خلاصة

البحث عن عريس لبنتك رحلة محتاجة صبر، دعاء، وذكاء. استخدمي كل الأدوات المتاحة، لكن ابقي حريصة ومحترسة.

[سجلي في وفّقنا مجاناً](/register?type=female) وشوفي الفرق.

ربنا يرزق بناتنا الأزواج الصالحين 🤲

## مراجع ومصادر رسمية

- [حكم إجبار الفتاة على الزواج من غير كفء لها — دار الإفتاء المصرية](https://www.dar-alifta.org/ar/fatwa/details/11511/%D8%AD%D9%83%D9%85-%D8%A5%D8%AC%D8%A8%D8%A7%D8%B1-%D8%A7%D9%84%D9%81%D8%AA%D8%A7%D8%A9-%D8%B9%D9%84%D9%89-%D8%A7%D9%84%D8%B2%D9%88%D8%A7%D8%AC-%D9%85%D9%86-%D8%BA%D9%8A%D8%B1-%D9%83%D9%81%D8%A1-%D9%84%D9%87%D8%A7)
- [حكم الإخبار بما في الخاطب من عيوب — دار الإفتاء المصرية](https://www.dar-alifta.org/ar/fatwa/details/22034/%D8%AD%D9%83%D9%85-%D8%A7%D9%84%D8%A5%D8%AE%D8%A8%D8%A7%D8%B1-%D8%A8%D9%85%D8%A7-%D9%81%D9%8A-%D8%A7%D9%84%D8%AE%D8%A7%D8%B7%D8%A8-%D9%85%D9%86-%D8%B9%D9%8A%D9%88%D8%A8)
- [خدمة الإرشاد الزواجي — دار الإفتاء المصرية](https://www.dar-alifta.org/ar/services/details/16/%D8%A7%D9%84%D8%A5%D8%B1%D8%B4%D8%A7%D8%AF-%D8%A7%D9%84%D8%B2%D9%88%D8%A7%D8%AC%D9%8A) — إرشاد أسري وللمقبلين على الزواج، بالتليفون أو الواتساب.
- [مركز الأزهر العالمي للفتوى الإلكترونية](https://azhar.eg/fatwacenter)
`,
  },
  {
    slug: 'zawaj-bidoon-nasab',
    title: 'النصب في مواقع الزواج: ٨ علامات + أفضل مواقع زواج آمنة في مصر',
    description: '٥ أساليب نصب متكررة في مواقع الزواج، ٨ علامات تكشف المحتال قبل ما تردّي عليه، خطوات الحماية قبل التواصل وفي المقابلة، وإيه تعملي لو حصل فعلاً.',
    keywords: ['نصب الزواج', 'احتيال مواقع زواج', 'حماية من النصب', 'زواج آمن'],
    category: 'الأمان',
    readTime: '6 دقائق',
    publishedAt: '2026-04-05',
    lastUpdated: '2026-08-06',
    content: `
## مقدمة

مع انتشار مواقع الزواج، انتشر كمان النصب والاحتيال. في ناس كتير خسرت فلوس، وقتها، وأحلامها بسبب محتالين. في المقال ده، هنعرف إزاي نحمي نفسنا.

## أشهر أساليب النصب

### 1. طلب فلوس بحجج مختلفة
- "أنا في بلد تانية وعايز فلوس علشان أجي أشوفك"
- "أهلي محتاجين مساعدة عاجلة"
- "أنا مسافر وضاعت فلوسي"

**الحل**: محدش محترم هيطلب منك فلوس قبل الزواج. نقطة.

وشرعاً، الفلوس اللي بتتاخد بالحيلة والكذب دي أكل لأموال الناس بالباطل — [التحذير من التلاعب بقصد أكل أموال الناس بالباطل — دار الإفتاء المصرية](https://www.dar-alifta.org/ar/fatwa/details/18550/%D8%A7%D9%84%D8%AA%D8%AD%D8%B0%D9%8A%D8%B1-%D9%85%D9%86-%D8%A7%D9%84%D8%AA%D9%84%D8%A7%D8%B9%D8%A8-%D8%A8%D9%82%D8%B5%D8%AF-%D8%A3%D9%83%D9%84-%D8%A3%D9%85%D9%88%D8%A7%D9%84-%D8%A7%D9%84%D9%86%D8%A7%D8%B3-%D8%A8%D8%A7%D9%84%D8%A8%D8%A7%D8%B7%D9%84).

### 2. صور مسروقة
بيسرقوا صور من الإنترنت ويدّعوا إنها بتاعتهم. بعدين يرفضوا المقابلة الحقيقية.

**الحل**: ابحث عن الصور في Google Images. لو ظهرت في مواقع تانية، ده نصب.

### 3. هوية مزورة
بيدّعوا إنهم دكاترة، مهندسين، أو عندهم وظائف كبيرة.

**الحل**: اطلب إثبات - كارنيه الشغل، صور من مكان العمل، معلومات قابلة للتحقق.

### 4. الاحتيال العاطفي
بيستثمروا وقت طويل في بناء العلاقة، وبعدين يطلبوا حاجة.

**الحل**: خدي وقتك. مهما كان "حلو"، مش سبب لإنك تصدقيه بدون تحقق.

### 5. البروفايلات الوهمية
بروفايلات مزيفة بالجملة، بتتعرف عليهم سريع.

**الحل**: استخدمي مواقع فيها **تحقق من الهوية** ومراجعة إدارية.

## علامات المحتال

⚠️ **بيطلب التواصل خارج التطبيق سريع**
⚠️ **بيقول إنه "حب من أول نظرة"**
⚠️ **بيرفض مكالمة فيديو**
⚠️ **قصصه مش منطقية**
⚠️ **بيستعجل جداً**
⚠️ **بيطلب معلومات شخصية حساسة**
⚠️ **عنده إجابة على كل حاجة بس بدون تفاصيل**
⚠️ **لغته غريبة أو بيكتب بترجمة Google**

## خطوات الحماية

### قبل التواصل:
1. **اقرأ البروفايل كويس**: تناقضات؟ معلومات ناقصة؟
2. **ابحث عن اسمه**: Google + Facebook
3. **شوف صوره**: Google Images reverse search

### أول التواصل:
1. **ماتديش معلومات شخصية حساسة**: عنوان، رقم حساب
2. **ماتبعتيش صور خاصة** - هذا تحرش
3. **وثّق المحادثات**: Screenshot للي بيحصل

### المقابلة:
1. **في مكان عام دايماً**
2. **مع ولي الأمر أو ناس موثوقين**
3. **في النهار**
4. **أبلغي شخص تاني بمكانك**

### بعد المقابلة:
1. **اسألي أهله وجيرانه**
2. **تحققي من شغله**
3. **لو حسيتي إن في حاجة غلط - وقفي**

## إيه اللي متقدريش تعمليه لو تعرضتي للنصب؟

### 1. لا تلومي نفسك
النصب ممكن يحصل لأي حد. مش ذنبك.

### 2. أبلغي الموقع
معظم المواقع المحترمة عندها نظام **إبلاغ**. استخدميه.

### 3. أبلغي الشرطة
لو خسرتي فلوس، قدمي بلاغ في قسم الشرطة.

ولو الواقعة كلها حصلت أونلاين، احتفظي بكل الأدلة (اسكرين شوت للمحادثات، الأرقام، لينكات الحسابات، إيصالات التحويل) واذكري في البلاغ إنها واقعة نصب إلكتروني.

### 4. شاركي تجربتك
تحذير الناس التانيين هيساعدهم.

## وفّقنا: أمان بمستوى مختلف

### ليه وفّقنا آمن؟

1. **إشراك ولي الأمر (اختياري)**: العروس تسجّل بنفسها أو يسجّلها ولي أمرها وتقدر تدعو وليّها للمتابعة
2. **مراجعة إدارية**: كل بروفايل بتمر على الإدارة
3. **تحقق من الهوية**: رفع صورة الهوية متاح
4. **مفيش صور منشورة**: حماية للخصوصية
5. **بلاغات فورية**: نظام إبلاغ سريع
6. **حظر فوري**: المحتالين بيتحظروا فوراً
7. **مفيش اشتراكات**: مفيش حد بيخسر فلوس

### تقارير المستخدمين
كل ما في بلاغ، الإدارة بتتحقق وبتاخد الإجراء اللازم.

## خلاصة

النصب في مواقع الزواج حقيقة، لكن تقدري تحمي نفسك بالحيطة والحذر. اختاري الموقع الصح، خدي وقتك، وخلي أهلك جزء من العملية.

[سجلي في وفّقنا مجاناً](/register) وابحثي بأمان.

ربنا يحفظكم من كل شر 🤲

## مراجع ومصادر رسمية

- [التحذير من التلاعب بقصد أكل أموال الناس بالباطل — دار الإفتاء المصرية](https://www.dar-alifta.org/ar/fatwa/details/18550/%D8%A7%D9%84%D8%AA%D8%AD%D8%B0%D9%8A%D8%B1-%D9%85%D9%86-%D8%A7%D9%84%D8%AA%D9%84%D8%A7%D8%B9%D8%A8-%D8%A8%D9%82%D8%B5%D8%AF-%D8%A3%D9%83%D9%84-%D8%A3%D9%85%D9%88%D8%A7%D9%84-%D8%A7%D9%84%D9%86%D8%A7%D8%B3-%D8%A8%D8%A7%D9%84%D8%A8%D8%A7%D8%B7%D9%84)
- [حكم الإخبار بما في الخاطب من عيوب — دار الإفتاء المصرية](https://www.dar-alifta.org/ar/fatwa/details/22034/%D8%AD%D9%83%D9%85-%D8%A7%D9%84%D8%A5%D8%AE%D8%A8%D8%A7%D8%B1-%D8%A8%D9%85%D8%A7-%D9%81%D9%8A-%D8%A7%D9%84%D8%AE%D8%A7%D8%B7%D8%A8-%D9%85%D9%86-%D8%B9%D9%8A%D9%88%D8%A8)
- [مركز الأزهر العالمي للفتوى الإلكترونية](https://azhar.eg/fatwacenter)
`,
  },
];

import { articlesMore } from './articles-more';
// English / German / French. Kept in their own file: articles-more.js is
// 663 KB of Arabic and every edit to it is a merge hazard.
import { articlesI18n } from './articles-i18n';

import { foundeloFiles } from './articles-foundelo';
import core from './foundelo-core';

const handWritten = [...articles, ...articlesMore, ...articlesI18n];

// Articles published by Foundelo (src/data/foundelo/), newest first, ahead of
// the hand-written ones. A slug a hand-written article already uses is skipped.
export const foundeloArticles = core.foundeloArticles(foundeloFiles, handWritten.map((a) => a.slug));

export const allArticles = [...foundeloArticles, ...handWritten];

export const articlesBySlug = allArticles.reduce((acc, article) => {
  acc[article.slug] = article;
  return acc;
}, {});

export const articleCategories = [...new Set(allArticles.map(a => a.category))];
